import Swal from 'sweetalert2'

const defaultParams = {
  buttonsStyling: false,
  padding: '24px'
}

const customClassKariermu = {
  image: 'm-0',
  title: 'mb-2 mt-3',
  confirmButton: 'ff-primary w-100 mb-0 button-primary-local btn-h-40 fs-14 fw-600',
  cancelButton: 'ff-primary w-100 mb-0 mt-2 button-link-local text-decoration-none btn-h-40 fs-14 fw-600 s-mt-5',
  content: 'p-0',
  header: 'p-0',
  closeButton: 'p-0 mt-4 mr-4 fs-24 btn-square-16 justify-content-end',
  actions: 'mt-3',
  popup: 'border-radius-10'
}

function swalFire ({
  width = 304,
  imageWidth = 192,
  imageHeight = 144,
  imageUrl,
  title,
  html,
  message,
  confirmButtonText,
  animation = true,
  showCloseButton = false,
  showCancelButton = false,
  cancelButtonText = 'Batal',
  allowOutsideClick = true,
  customClass = {
    confirmButton: '',
    cancelButton: ''
  }
}) {
  return Swal.fire({
    ...defaultParams,
    width,
    imageWidth, // Specify to Avoid Content Jumping
    imageHeight, // Specify to Avoid Content Jumping
    showCloseButton,
    showCancelButton,
    cancelButtonText,
    confirmButtonText,
    allowOutsideClick,
    title: `<p class="ff-primary mb-0 text-royal-navy-900 fs-18">${title}</p>`,
    html: html || `<p class="font-paragraph-5 text-ui-primary text-center m-0">${message}</p>`,
    imageUrl,
    animation,
    customClass: {
      ...customClassKariermu,
      confirmButton: customClassKariermu.confirmButton + ' ' + customClass.confirmButton,
      cancelButton: customClassKariermu.cancelButton + ' ' + customClass.cancelButton
    }
  })
}

export { swalFire }
